import MailListItemAnimationStore from './schema/MailListItemAnimationStore';
import { createStore } from 'satcheljs';

const MailListItemAnimationDefaultStore: MailListItemAnimationStore = {
    animationAction: null,
    animationRowIds: null,
    animationCallbacks: null,
    prefersMotion: null,
};

export const mailListItemAnimationStore = createStore<MailListItemAnimationStore>(
    'MailItem',
    MailListItemAnimationDefaultStore
)();
export const getStore = () => mailListItemAnimationStore;
